// extracted by mini-css-extract-plugin
module.exports = {"deleteItemButton":"tertiaryDeleteButton_deleteItemButton__2FGIL"};